module.exports = __webpack_public_path__ + "static/media/icons8-about-500.eed5fb64.png";